import { useMemo, useState } from "react";
import { colors } from "@/constant/colors";

interface FillingQuestionProps {
  question: string;
  answer: string;
  userInput: string[];
  submit: boolean;
  className?: string;
  isReview?: boolean;
}

const FillingQuestion = ({ question, answer, userInput, submit, className, isReview = false }: FillingQuestionProps) => {

  const questionParts = useMemo(() => {
    // Support both {blank} and [BLANK] formats
    if (!question || typeof question !== 'string') {
      return [''];
    }
    return question.split(/\{blank\}|\[BLANK\]/g);
  }, [question]);

  return (
    <div className={`text-xl w-full ${className} text-center px-5`} style={{ lineHeight: 2, color: colors.mainTextColor }}>
      {questionParts.map((part: string, idx: number) => {
        const currentUserInput = userInput && userInput[idx] ? userInput[idx] : '';
        return (
          <span key={idx}>
            {part}
            {idx < questionParts.length - 1 && (
              <span
                style={{
                  display: 'inline-block',
                  width: `${Math.max(currentUserInput.length * 18, 50)}px`,
                  borderBottom: '2px solid #735648',
                  margin: '0 4px',
                  height: '1.5em',
                  textAlign: 'center',
                  fontWeight: 600,
                  color: colors.mainTextColor,
                  backgroundColor: (currentUserInput.trim() === "" || !submit) && !isReview ? "" : (() => {
                    const answers = Array.isArray(answer) ? answer : [answer];
                    const expectedAnswer = answers[idx];
                    return currentUserInput.trim().toLowerCase() === String(expectedAnswer || '').trim().toLowerCase() ? colors.correctAnswerColorLight : colors.wrongAnswerColorLight;
                  })()
                }}
              >
                {currentUserInput}
              </span>
            )}
          </span>
        );
      })}
    </div>)
};

export default FillingQuestion;